module.exports = __webpack_public_path__ + "Footer_Logo-cc517bc0c78ce72dfce288b4e0ce625c.png";